document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.nobull-footer #footer-newsletter');
  const emersysApiURL = document.querySelector(
    '.nobull-footer #EmarsysAPIURL',
  )?.value;

  // Function to validate email input
  function validateInput(input, errorMessage, message) {
    if (!input.checkValidity() || input.value.trim() === '') {
      errorMessage.textContent = message; // Show error message
      errorMessage.classList.remove('hidden'); // Unhide the error message
      return false;
    } else {
      errorMessage.classList.add('hidden'); // Hide the error message if input is valid
      return true;
    }
  }

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const emailInput = form.querySelector(
        '.nobull-footer input[type="email"]',
      );
      const footerFormBtn = form.querySelector(
        '.nobull-footer .footer-column--news-btn-icon',
      );
      const agreeText = form.querySelector(
        '.nobull-footer .footer-column--news-agree-text',
      );
      const emailErrorMessage = form.querySelector(
        '.nobull-footer .error-message-email',
      );
      const thankYouMessage = form.querySelector(
        '.nobull-footer .thankyou-message',
      );

      let isValid = validateInput(
        emailInput,
        emailErrorMessage,
        'Please enter a valid email address.', // Error message for invalid email
      );

      if (isValid) {
        try {
          // API call to Emarsys create-contact endpoint
          const options = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'api-key': 'eabfeb7d-5a60-4a7f-b151-c7715be9e1f8', // Replace with your actual API key
            },
            body: JSON.stringify({
              email: emailInput.value,
              firstname: '',
              lastname: '',
              shopify_opt: '1',
              opt_in_source: 'website',
              opt_source_detail: 'footer',
            }),
          };

          const response = await fetch(
            `${emersysApiURL}/create-contact`,
            options,
          );

          if (response.ok) {
            // On success: hide email input, show thank you message
            emailInput.classList.add('hidden');
            footerFormBtn.classList.add('hidden');
            agreeText.classList.add('hidden');
            thankYouMessage.classList.remove('hidden');
            thankYouMessage.classList.add('flex');
            emailErrorMessage.classList.add('hidden'); // Ensure error message is hidden
          } else {
            throw new Error('Network error occurred'); // Handle API error
          }
        } catch (error) {
          emailErrorMessage.textContent =
            'An error occurred. Please try again.';
          emailErrorMessage.classList.remove('hidden'); // Show error message
        }
      }
    });
  });
});
